<template>
  <div>
    <h6 style="text-align: center;">学期列表</h6>
    <el-button type="primary" style="display: block; margin-left: auto; margin-right: auto;" @click="showInputBox">新增学期</el-button>
    <el-table :data="semesterList" style="width: 100%">
      <el-table-column prop="name" label="学期名称"></el-table-column>
      <el-table-column prop="uuid" label="UUID"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
import { ref } from 'vue';
import { ElMessageBox, ElMessage, ElTable, ElTableColumn, ElButton } from 'element-plus';

export default {
  components: {
    ElTable,
    ElTableColumn,
    ElButton
  },
  setup() {
    const semesterList = ref([]);

    const fetchSemesters = async () => {
      try {
        const response = await axios.get('/api/semesters/data');
        semesterList.value = response.data.semesters;
      } catch (error) {
        ElMessage.error('获取学期信息失败');
      }
    };

    const showInputBox = () => {
      ElMessageBox.prompt('请输入学期名称', '新增学期', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        addSemester(value);
      }).catch(() => {});
    };

    const addSemester = async (name) => {
      try {
        const response = await axios.post('/api/semesters', { name });
        if (response.status === 201) {
          ElMessage.success('学期添加成功');
          fetchSemesters(); // 刷新列表
        } else {
          ElMessage.error('学期添加失败');
        }
      } catch (error) {
        ElMessage.error('学期添加失败');
      }
    };

    fetchSemesters(); // 初始加载

    return { semesterList, showInputBox };
  },
};
</script>